import { type MarketLayout } from "@/app/(site)/[locale]/checkout/types"

interface FieldOrder {
    fieldStyle: string
}

interface AddressFormConfig {
    fields: Record<string, FieldOrder>
}

// Function to generate address form configuration based on market layout and state requirements
const getAddressFormConfig = (
    marketLayout: MarketLayout,
    hasStates: boolean
): AddressFormConfig => {
    const baseConfigs: Record<MarketLayout, AddressFormConfig> = {
        na: {
            fields: {
                firstName: {
                    fieldStyle: "order-1 col-span-6"
                },
                lastName: {
                    fieldStyle: "order-2 col-span-6"
                },
                address: {
                    fieldStyle: "order-3 col-span-6"
                },
                apartmentHouseNumber: {
                    fieldStyle: "order-4 col-span-6"
                },
                city: {
                    fieldStyle: "order-5 col-span-6"
                },
                state: {
                    fieldStyle: "order-6 col-span-6 md:col-span-3"
                },
                zipCode: {
                    fieldStyle: `order-7 col-span-6 md:col-span-3`
                },
                phone: {
                    fieldStyle: "order-8 col-span-6"
                },
                country: {
                    fieldStyle: "order-9 col-span-6"
                }
            }
        },
        eu: {
            fields: {
                firstName: {
                    fieldStyle: "order-1 col-span-6"
                },
                lastName: {
                    fieldStyle: "order-2 col-span-6"
                },
                address: {
                    fieldStyle: "order-3 col-span-6"
                },
                apartmentHouseNumber: {
                    fieldStyle: "order-4 col-span-6"
                },
                zipCode: {
                    fieldStyle: `order-5 col-span-6 ${hasStates ? "md:col-span-2" : "md:col-span-3"}`
                },
                city: {
                    fieldStyle: `order-6 col-span-6 md:order-5 ${hasStates ? "md:col-span-2" : "md:col-span-3"}`
                },
                state: {
                    fieldStyle: "order-7 col-span-6 md:order-7 md:col-span-2"
                },
                phone: {
                    fieldStyle: "order-8 col-span-6"
                },
                country: {
                    fieldStyle: "order-9 col-span-6"
                }
            }
        }
        // more layouts per market can be added here.
    }

    return baseConfigs[marketLayout]
}

export const getFieldOrder = (
    layout: MarketLayout,
    fieldName: string,
    hasStates: boolean
): FieldOrder => {
    const config = getAddressFormConfig(layout, hasStates)
    return (
        config.fields[fieldName] || {
            fieldStyle: "order-999"
        }
    )
}

export const getFieldClasses = (
    layout: MarketLayout,
    fieldName: string,
    hasStates: boolean
): string => {
    const order = getFieldOrder(layout, fieldName, hasStates)
    return `${order.fieldStyle}`
}
